/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import {
  Card,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import _ from 'lodash';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import Button, { BackButton } from '../../components/Button';
import billGoldReport from 'components/Report/Gold/billGoldReport';
import billbuyGoldReport from 'components/Report/Gold/billbuyGoldReport';
import dayjs from 'dayjs';

export default function DetailOrderGold({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [imagePreview, setImagePreview] = useState({ open: false, url: '' });
  const goldReport = useSelector((state) => state.gold);
  const me = useSelector((state) => state?.me?.userData);
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleNavigateToEdit = () => {
    history.push(`/gold/edit-order-gold/${id}`);
  };

  const handleNavigateToGoldBill = () => {
    billGoldReport(goldReport);
  };

  const handleNavigateToBuyBill = () => {
    billbuyGoldReport(goldReport);
  };

  const handleOpenPaymentModal = () => {
    setOpenPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setOpenPaymentModal(false);
  };

  const handleImageClick = (url) => {
    setImagePreview({ open: true, url });
  };

  const handleCloseImagePreview = () => {
    setImagePreview({ open: false, url: '' });
  };

  useEffect(() => {
    dispatch(actions.goldTransactionGet(id));
    return () => {};
  }, []);

  const renderDetailCustomer = () => (
    <div>
      <div className="py-2 pl-2 bg-yellow-500 rounded-sm border-1 border-black text-center">
        ข้อมูลลูกค้า
      </div>
      <div className="py-4 px-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">ชื่อลูกค้า:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.name || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">วันเกิด:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.born
                  ? dayjs(goldReport.customer.born).format('DD/MM/YYYY')
                  : 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">ที่อยู่:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.address || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">
                เลขบัตรประชาชน:
              </span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.cardId || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">เบอร์โทร:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.tel || 'ไม่ระบุ'}
              </span>
            </div>
            {goldReport?.customer?.tax?.taxnumber && (
              <div className="flex flex-wrap">
                <span className="font-medium w-full sm:w-1/3">
                  เลขประจำตัวผู้เสียภาษี:
                </span>
                <span className="w-full sm:w-2/3">
                  {goldReport.customer.tax.taxnumber}
                </span>
              </div>
            )}
          </div>
          <div className="space-y-2">
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">Facebook:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.social?.facebook || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">Line ID:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.social?.line || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">Email:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.social?.email || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">อาชีพ:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.customer?.job || 'ไม่ระบุ'}
              </span>
            </div>
            <div className="flex flex-wrap">
              <span className="font-medium w-full sm:w-1/3">ผู้ขาย:</span>
              <span className="w-full sm:w-2/3">
                {goldReport?.saler || 'ไม่ระบุ'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDetailOrder = () => (
    <div className="overflow-x-auto">
      <Paper>
        <TableContainer>
          <Table size="small" className="border-lg min-w-full">
            <TableHead className="bg-yellow-100">
              <TableRow>
                <TableCell align="center" className="min-w-[50px]">
                  <div className="font-bold text-xs">ลำดับ</div>
                </TableCell>
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">วันที่</div>
                </TableCell>
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">สินค้า</div>
                </TableCell>
                <TableCell align="center" className="min-w-[80px]">
                  <div className="font-bold text-xs">น้ำหนัก</div>
                </TableCell>
                <TableCell align="center" className="min-w-[80px]">
                  <div className="font-bold text-xs">ประเภท</div>
                </TableCell>
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">หมายเหตุ</div>
                </TableCell>
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">ราคาทองสมาคม</div>
                </TableCell>
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">จำนวนเงินรวมภาษี</div>
                </TableCell>
                {/* <TableCell align="center" className="min-w-[120px]">
                  <div className="font-bold text-xs">ราคาก่อนภาษี</div>
                </TableCell>
                <TableCell align="center" className="min-w-[120px]">
                  <div className="font-bold text-xs">ราคาซื้อคืน/กรัม</div>
                </TableCell>
                <TableCell align="center" className="min-w-[120px]">
                  <div className="font-bold text-xs">ราคาซื้อคืน/บาท</div>
                </TableCell> */}
                <TableCell align="center" className="min-w-[100px]">
                  <div className="font-bold text-xs">ภาษีมูลค่าเพิ่ม</div>
                </TableCell>
                <TableCell align="center" className="min-w-[80px]">
                  <div className="font-bold text-xs">รูปภาพ</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(goldReport?.order) ? (
                _.map(goldReport.order, (_order, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    className={index % 2 === 0 ? 'bg-gray-50' : ''}
                  >
                    <TableCell align="center" className="text-xs">
                      {index + 1}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {dayjs(goldReport?.date).format('DD/MM/YY HH:mm')}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.material?.name || '-'}
                      {_order?.place === 'คลังรูปพรรณเก่า' ? 'เก่า' : 'ใหม่'}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.weight}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.material?.material_type?.name || '-'}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.note || '-'}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.gold_official?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell>
                    <TableCell align="center" className="text-xs">
                      {_order?.cost?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell>
                    {/* <TableCell align="center" className="text-xs">
                      {_order?.totalbeforeVat?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell> */}
                    {/* <TableCell align="center" className="text-xs">
                      {_order?.pricebackpergram?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell> */}
                    {/* <TableCell align="center" className="text-xs">
                      {_order?.pricebackperbath?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell> */}
                    <TableCell align="center" className="text-xs">
                      {_order?.vat?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || ''}
                    </TableCell>
                    <TableCell align="center">
                      {_order?.image?.url ? (
                        <img
                          src={_order.image.url}
                          alt={_order?.material?.name || 'Product'}
                          className="w-12 h-12 object-cover rounded cursor-pointer hover:shadow-lg transition-shadow"
                          onClick={() => handleImageClick(_order.image.url)}
                        />
                      ) : (
                        <div className="w-12 h-12 bg-gray-200 rounded flex items-center justify-center">
                          <i className="fa-solid fa-image text-gray-400 text-lg" />
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12}>
                    <div className="text-center py-4">ไม่มีรายการ</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );

  const detailPaymentOrder = () => (
    <div className="py-4 text-center">
      <button
        onClick={handleOpenPaymentModal}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        <i className="fa-solid fa-credit-card mr-2" />
        ดูรายละเอียดการชำระเงิน
      </button>
    </div>
  );

  const renderPaymentModal = () => (
    <Dialog
      open={openPaymentModal}
      onClose={handleClosePaymentModal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" className="font-bold text-center">
          รายละเอียดการชำระเงิน
        </Typography>
      </DialogTitle>
      <DialogContent>
        <div className="py-2">
          {goldReport?.payment?.cash?.status && (
            <div className="mb-4">
              <Card className="p-3 border-l-4 border-green-500">
                <div className="flex items-center mb-2">
                  <i className="fa-solid fa-money-bill text-green-500 text-xl mr-2" />
                  <Typography variant="h6" className="font-bold text-green-600">
                    การชำระด้วยเงินสด
                  </Typography>
                </div>
                <Typography variant="body1">
                  จำนวนเงิน:{' '}
                  <span className="font-bold">
                    {goldReport.payment.cash.amount?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{' '}
                    บาท
                  </span>
                </Typography>
              </Card>
            </div>
          )}

          {goldReport?.payment?.transfer?.status && (
            <div className="mb-4">
              <Card className="p-3 border-l-4 border-blue-500">
                <div className="flex items-center mb-2">
                  <i className="fa-solid fa-university text-blue-500 text-xl mr-2" />
                  <Typography variant="h6" className="font-bold text-blue-600">
                    การชำระด้วยการโอนเงิน
                  </Typography>
                </div>
                <Typography variant="body1" className="mb-1">
                  จำนวนเงิน:{' '}
                  <span className="font-bold">
                    {goldReport.payment.transfer.amount?.toLocaleString(
                      'en-US',
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}{' '}
                    บาท
                  </span>
                </Typography>
                {goldReport.payment.transfer.bank && (
                  <>
                    <Divider className="my-2" />
                    <Typography variant="body2" className="mb-1">
                      <span className="font-semibold">ธนาคาร:</span>{' '}
                      {goldReport?.payment.transfer.bank.name}
                    </Typography>
                    <Typography variant="body2" className="mb-1">
                      <span className="font-semibold">ชื่อบัญชี:</span>{' '}
                      {goldReport?.payment.transfer.bank.bankName}
                    </Typography>
                    <Typography variant="body2">
                      <span className="font-semibold">เลขบัญชี:</span>{' '}
                      {goldReport?.payment.transfer.bank.accountNumber}
                    </Typography>
                  </>
                )}
              </Card>
            </div>
          )}

          {goldReport?.payment?.credit?.status && (
            <div className="mb-4">
              <Card className="p-3 border-l-4 border-yellow-500">
                <div className="flex items-center mb-2">
                  <i className="fa-solid fa-credit-card text-yellow-500 text-xl mr-2" />
                  <Typography
                    variant="h6"
                    className="font-bold text-yellow-600"
                  >
                    การชำระด้วยเครดิต
                  </Typography>
                </div>
                <Typography variant="body1">
                  จำนวนเงิน:{' '}
                  <span className="font-bold">
                    {goldReport.payment.credit.amount?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{' '}
                    บาท
                  </span>
                </Typography>
              </Card>
            </div>
          )}

          <Divider className="my-3" />
          <div className="bg-gray-100 p-3 rounded">
            <Typography variant="h6" className="font-bold text-center">
              ยอดรวมทั้งหมด:{' '}
              {[
                goldReport?.payment?.cash?.amount || 0,
                goldReport?.payment?.transfer?.amount || 0,
                goldReport?.payment?.credit?.amount || 0,
              ]
                .reduce((sum, amount) => sum + amount, 0)
                .toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{' '}
              บาท
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button
          onClick={handleClosePaymentModal}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
        >
          ปิด
        </button>
      </DialogActions>
    </Dialog>
  );

  const renderImagePreviewModal = () => (
    <Dialog
      open={imagePreview.open}
      onClose={handleCloseImagePreview}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" className="font-bold text-center">
          รูปภาพสินค้า
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" p={2}>
          <img
            src={imagePreview.url}
            alt="Product Preview"
            className="max-w-full max-h-96 object-contain rounded"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <button
          onClick={handleCloseImagePreview}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
        >
          ปิด
        </button>
      </DialogActions>
    </Dialog>
  );

  return (
    <div className="p-4">
      <div>{renderTitle()}</div>
      <div className="flex flex-row justify-start pb-4">
        <BackButton />
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center pb-4 gap-4">
        <div className="text-xl font-bold">
          {goldReport?.gold_transaction_type === 'SALE'
            ? 'รายละเอียดการขายทอง'
            : 'รายละเอียดการซื้อทอง'}
        </div>
        <div className="flex flex-row gap-2">
          {/* {me?.department?.access?.OTHER?.editGoldTransaction && (
            <Tooltip title="แก้ไขข้อมูล" placement="top" arrow>
              <IconButton onClick={handleNavigateToEdit}>
                <i className="fa-solid fa-edit text-2xl text-blue-500 hover:text-blue-700" />
              </IconButton>
            </Tooltip>
          )} */}
          <Tooltip title="พิมพ์ใบเสร็จ" placement="top" arrow>
            <IconButton
              onClick={() => {
                if (goldReport?.gold_transaction_type === 'SALE') {
                  handleNavigateToGoldBill();
                } else if (goldReport?.gold_transaction_type === 'BUY') {
                  handleNavigateToBuyBill();
                }
              }}
            >
              <i className="fa-solid fa-print text-2xl text-gray-500 hover:text-gray-700" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <Card className="p-4">
        <div className="space-y-6">
          {renderDetailCustomer()}
          {renderDetailOrder()}
          {detailPaymentOrder()}
        </div>
      </Card>
      {renderPaymentModal()}
      {renderImagePreviewModal()}
    </div>
  );
}

DetailOrderGold.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailOrderGold.defaultProps = {
  title: '',
  subtitle: '',
};
